<template>
    <div class="accommodation-list">
      <template v-for="result in results">
        <search-card-v2
            v-if="useNewCard"
            @update-view-mode-with-focus="showResultOnMap"
            :result="result"
            :key="'v2-' + result.id"
        />
        <result-card
            v-else
            @update-view-mode-with-focus="showResultOnMap"
            :result="result"
            :key="result.id"
        />
      </template>
    </div>
    <div class="d-flex justify-content-center">
      <Pagination
          :pager="pager"
          @go-to-page="goToPage"
      ></Pagination>
    </div>
</template>

<script>
import ResultCard from "./ResultCard";
import SearchCardV2 from "./SearchCardV2";
import Pagination from "../../Pagination";

export default {
  name: "ListView",
  components: {Pagination, ResultCard, SearchCardV2},
  props: {
    results: [],
    pager: {},
  },
  data() {
    return {
      useNewCard: true,
    }
  },
  methods: {
    showResultOnMap(result) {
      this.$emit('update-view-mode-with-focus', result)
    },
    goToPage(index) {
      this.$emit('go-to-page', index);
    }
  }
}
</script>

<style scoped>

</style>